import React from 'react';
import classNames from 'classnames';

const ModalTitle: React.FC<{ className?: string }> = ({
  children,
  className,
}) => (
  <div className={classNames('mb-3 text-xl text-center', className)}>
    {children}
  </div>
);

export default ModalTitle;
